@if (['EWALLET'].includes(depositSubmitResponse?.family)) {
    @if (showPixProcessPage()) {
        <app-pix-status-process [processingAmount]="processingAmount" [brandId]="brandId" />
    } @else {
        <app-wallet-process [depositSubmitResponse]="depositSubmitResponse" (showPixPage)="updatePageStatus($event)" />
    }
}
